import React from 'react';
import { useAuth } from 'contexts/AuthContext';
import { PageContainer, PageHeader, Breadcrumb, PageTitle, Card } from 'styles/common.styles';

/**
 * 예산관리 모듈 홈 (대메뉴 진입용 대시보드)
 * — 인사와 동일한 셸(탭·즐겨찾기·그리드 공통기능)을 사용한다.
 */
const BudgetDashboard = () => {
  const { user, compCd } = useAuth();

  return (
    <PageContainer>
      <PageHeader>
        <Breadcrumb>
          <span>예산관리</span>
          <span className="separator">›</span>
          <span className="current">대시보드</span>
        </Breadcrumb>
        <PageTitle>예산관리 대시보드</PageTitle>
      </PageHeader>
      <Card style={{ padding: 24, lineHeight: 1.7 }}>
        <p><strong>로그인 사용자</strong>: {user?.name || user?.username} ({user?.id})</p>
        <p><strong>기관코드</strong>: {compCd || user?.compCd}</p>
        <hr style={{ margin: '16px 0' }} />
        <p>
          예산관리 모듈입니다. 메뉴·탭·즐겨찾기·HiGrid 공통 기능은 인사관리와 동일하게 사용할 수 있습니다.
        </p>
        <p style={{ marginTop: 12 }}>
          <strong>예산과목구조관리</strong>에서 기관별 레벨체계를 확정한 뒤,{' '}
          <strong>예산과목등록</strong>에서 단일 테이블로 과목을 등록합니다. 확정된 레벨은 이후 편성·배정·품의·원인행위·지출결의 화면 컬럼의 기준이 됩니다.
        </p>
        <p style={{ color: '#6B7280', fontSize: '0.9rem', marginTop: 12 }}>
          공통 UI: `docs/COMMON_UI_FEATURES.md`
        </p>
      </Card>
    </PageContainer>
  );
};

export default BudgetDashboard;
